import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=3a4c4d6a&"
import script from "./CategoryEdit.js?vue&type=script&lang=js&"
export * from "./CategoryEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports